import type { VariantResource } from "../../variant";
import type { OwnerResource } from "../../owner";
import type { SupplierResource } from "../../supplier";
import type { WarehouseResource } from "../../warehouse";
import type { WarehousePlaceResource } from "../../warehouse-place";
import type { ConditionResource } from "../../condition";

export interface StockResource {
  id: string;
  gid: string;
  variant_id: string;
  variant_sku: string;
  variant_title: string;
  variant_ean: string;
  reserve_stock: number;
  supplier_id: string;
  supplier_company: string;
  supplier_number: string;

  is_commission: boolean;
  is_fremdware: boolean;
  best_before_date: string;
  amount: string;
  orders: {
    id: string;
    company: string;
    gid: string;
    number: string;
    first_name: string;
    last_name: string;
    order_date: string;
  }[];
  freely_available_stock: number;
  physical_stock: number;
  orders_count: number;

  purchase_price: string;
  total_purchase_price: string;
  owner_id: string;
  warehouse_id: string;
  warehouse_place_id: string;
  stock: string;
  variant?: VariantResource;
  owner?: OwnerResource;
  commission_supplier?: SupplierResource;
  warehouse?: WarehouseResource;
  warehouse_place?: WarehousePlaceResource;
  condition?: ConditionResource;
}

export enum StockMoveOperationEnum {
  InOperationBuying = "InOperationBuying",
  InOperationInventory = "InOperationInventory",
  InOperationReturn = "InOperationReturn",
  InOperationAdjustment = "InOperationAdjustment",
  OutOperationInventory = "OutOperationInventory",
  OutOperationBestBeforeDate = "OutOperationBestBeforeDate",
  OutOperationPromotion = "OutOperationPromotion",
  OutOperationAdjustment = "OutOperationAdjustment",
  TransferOperation = "TransferOperation",
  TransferOperationOwner = "TransferOperationOwner",
}
